import apiService from './apiService';

export default (function() {

	var servicePath = '/MediaShare';

	// Get media share item
	function get(token) {
		var url = servicePath + '/' + token;

		return apiService.get(url);
	}

	function getPublic(token) {
		var url = servicePath + '/' + token + '/public';

		return apiService.get(url);
	}


	function link(id, version, advisorId, shareType, advisorPartnerId) {
		var params = {
			id: id,
			version: version,
			type: shareType
		};

		if (advisorId) {
			params.advisorId = advisorId;
			params.advisorPartnerId = advisorPartnerId;
		}
		const url = servicePath + '/link' + apiService.paramsToQuery(params);

		return apiService.get(url);
	}

	function add(mediaid, token, advisorId, shareType, advisorPartnerId) {
		var params = {
			token: token,
			type: shareType,
			advisorId: advisorId,
			advisorPartnerId: advisorPartnerId
		};
		var url = servicePath + '/' + mediaid + '/add' + apiService.paramsToQuery(params);

		return apiService.post(null, url);
	}

	return {
		get: get,
		getPublic: getPublic,
		link: link,
		add: add
	};
})();